import React, { Component } from 'react';

export default function(ComposedComponent) {
  return class Redirect extends Component {

    componentWillMount() {
      const token = localStorage.getItem('token');
      if (token) {
        this.props.history.push('/dashboard');
      }
    }

    // componentWillUpdate(nextProps) {
    //   if (!nextProps.authenticated) {
    //     this.props.history.push('/');        
    //   }
    // }

    render() {
      return <ComposedComponent {...this.props} />
    }
  }

}